import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'
import heroLogo from '@/assets/images/works/projects/cassian/cassian-logo.png'

export default {
  meta: {
    title: 'CASSIAN',
    headline: 'Asesores de <br> <span class="text-electric-purple">Confianza.</span>',
    label: 'Caso de Estudio 03',
    description:
      ' Renovación digital integral para una firma líder de auditoría y asesoramiento en Tanzania.',
    chips: [
      { text: 'Corporativo', dotColor: 'bg-orange-500' },
      { text: 'Fintech', dotColor: 'bg-blue-500' },
      { text: '2023' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1920&auto=format&fit=crop',
    heroLogo: heroLogo,
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Cliente', value: 'Cassian & Associates' },
      { label: 'Tipo', value: 'Sitio Corporativo' },
      { label: 'Rol', value: 'Diseñador Líder & Desarrollador' },
      { label: 'Stack', value: 'Vue 3, Tailwind CSS, GSAP' },
      { label: 'Ubicación', value: 'Dar Es Salam, Tanzania (Remoto)' },
      { label: 'Año', value: '2023' },
    ],
    cta: 'Ver Sitio',
    ctaLink: 'https://cassian.co.tz/',
    secondaryCta: 'Ver Código',
    secondaryCtaLink: '#',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Resumen',
      title: 'Contexto del Proyecto',
      highlight:
        'El objetivo central fue ejecutar una renovación integral de la marca corporativa y el sitio web de Cassian para elevar la imagen de la empresa y la experiencia del usuario.',
      cards: [
        { title: 'Cliente', text: 'Cassian & Associates' },
        { title: 'Sector', text: 'Servicios Fiscales & Corporativos' },
        { title: 'Servicios', text: 'Branding, Desarrollo Web, UX/UI' },
        { title: 'Resultado', text: '+40% Gen. Leads' },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Concepto',
      label: 'El Desafío',
      title: 'Modernizando la Tradición',
      description:
        'Las firmas fiscales a menudo se sienten rígidas. Necesitábamos transmitir <strong>autoridad y precisión</strong> mientras parecíamos modernos, accesibles y tecnológicos. El desafío fue equilibrar estas fuerzas opuestas en una identidad digital cohesiva.',
      tags: ['Rebranding', 'Vue 3', 'Rendimiento', 'SEO'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Desafío',
      title: 'El Problema',
      description:
        'La presencia digital anterior no reflejaba la escala y experiencia real de la firma. Los usuarios encontraban difícil navegar por ofertas de servicios complejas, lo que llevaba a altas tasas de rebote.',
      stats: [
        { value: '3.5s', label: 'Carga Promedio' },
        { value: '65%', label: 'Tráfico Móvil' },
        { value: '15%', label: 'Tasa de Rebote' },
      ],
    },
    transformacion: {
      id: 'transformacion',
      menuLabel: 'Comparación',
      title: 'Antes y Después',
      beforeLabel: 'Sitio Antiguo',
      afterLabel: 'Sitio Nuevo',
      instruction: 'Arrastra para comparar',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    branding: {
      id: 'branding',
      menuLabel: 'Identidad',
      title: 'Identidad Visual',
      description:
        'Un lenguaje de diseño audaz y profesional que equilibra la confianza con el dinamismo moderno.',
      palette: [
        { name: 'Naranja Principal', hex: '#FF5D16' },
        { name: 'Oscuro Profesional', hex: '#1A1A24' },
        { name: 'Azul Acento', hex: '#00B6EA' },
        { name: 'Blanco Puro', hex: '#FFFFFF' },
      ],
      typography: 'Filson Soft (Títulos) + Noto Sans (Cuerpo)',
      gallery: [
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Papeleria',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Redes+Sociales',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Tarjeta+Presentacion',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Merch',
      ],
    },
    proceso: {
      id: 'proceso',
      menuLabel: 'Proceso',
      title: 'Proceso de Desarrollo',
      subtitle: 'Un Enfoque por Fases',
      description: `
        <div class="space-y-4">
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 1: Investigación y Análisis</strong> Investigación exhaustiva de la marca Cassian y la competencia, definiendo objetivos específicos del proyecto y analizando tendencias actuales de diseño web.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 2: Diseño y Desarrollo</strong> Definición de elementos visuales (logo, paleta, tipografia) y construcción del nuevo sitio web corporativo utilizando Vue 3 y Tailwind CSS.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 3: Pruebas y Lanzamiento</strong> Pruebas exhaustivas para garantizar una UX óptima, seguidas del lanzamiento oficial e implementación de la nueva identidad corporativa.</div>
        </div>
      `,
      images: [
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+1',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+2',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+3',
      ],
    },
    solucion: {
      id: 'solucion',
      menuLabel: 'Galería',
      label: 'Resultado Final',
      title: 'La Experiencia',
      images: [
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Vista+Movil',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Pagina+Servicios',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Sobre+Nosotros',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Contacto',
      ],
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tecnología',
      title: 'Ingeniería',
      description: 'Una arquitectura de stack moderna diseñada para escalabilidad y rendimiento.',
      categories: [
        { name: 'Diseño', items: ['Figma', 'Photoshop', 'Illustrator', 'Adobe Fonts'] },
        { name: 'Frontend', items: ['Vue 3', 'Composition API', 'Vite'] },
        { name: 'Estilos', items: ['Tailwind CSS', 'SCSS', 'PostCSS'] },
        { name: 'Estado/Lógica', items: ['Pinia', 'Firebase', 'Axios'] },
      ],
    },
  },
}
